import { useSelfSignupUserCheck } from 'src/hooks/use-self-signup-user-check.hook';
import { useUserOrgs } from 'src/hooks/use-user-orgs';
import AuthService from 'src/services/api/auth.service';
import { useGetUserCustomGroupsQuery } from 'src/store/api/shared-exp-bff';

export const useUserCustomGroups = () => {
  const isTeacher = AuthService.isTeacher();
  const isSelfSignupUser = useSelfSignupUserCheck();
  const { hasActiveOrg } = useUserOrgs();

  const isSSUCheckInProgress = isSelfSignupUser === null;
  const shouldSkipQuery =
    !isTeacher || isSSUCheckInProgress || isSelfSignupUser || !hasActiveOrg;

  const result = useGetUserCustomGroupsQuery(undefined, {
    skip: shouldSkipQuery,
  });

  return {
    // checking isError won't help because it will be reset after re-render unlike error object
    isLoadingWithoutError: result.isLoading && !result.error,
    ...result,
  };
};
